import { createTestIds } from "../../util/createTestIds";

export default createTestIds("markdown", ["container"] as const);
